import { ENUM_RETURNS_STATUS } from 'models/common.model';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';

export type KitchenExcessReturnsType = {
  cokitchen_id: string;
  id: string;
  note: string;
  status: ENUM_RETURNS_STATUS;
  items: {
    id: string;
    ingredient_id: string;
    quantity: 3;
    return_id: string;
    ingredient: {
      id: string;
      category: string;
      min_vendor_price: string;
      min_quantity: string;
      unit_type: string;
      unit_weight: string;
      name: string;
    };
  }[];
};

export type KitchenExcessReturnContextType = {
  setExcessReturnToUpdate: Dispatch<SetStateAction<KitchenExcessReturnsType>>;
  excessReturnToUpdate: KitchenExcessReturnsType;
};

export const KitchenExcessReturnContext = createContext({} as KitchenExcessReturnContextType);
const useKitchenExcessReturnContext = () => {
  const context = useContext(KitchenExcessReturnContext);
  return context;
};

export default useKitchenExcessReturnContext;
